import { ref, onUnmounted, watch } from 'vue';
import { useAppStore } from '@/stores/app-store';

export function useLoadingDelay(minDelay = 500) {
  const loading = ref(true);
  let timeoutId = null;

  const finish = (start) => {
    const elapsed = Date.now() - start;
    if (elapsed < minDelay) {
      timeoutId = setTimeout(() => {
        loading.value = false;
      }, minDelay - elapsed);
    } else {
      loading.value = false;
    }
  };

  const stop = () => {
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
    loading.value = false;
  };

  const app = useAppStore();
  const stopWatch = watch(
    () => app.isLoading,
    (isGlobalLoading) => {
      if (!isGlobalLoading) {
        stop();
      }
    },
    { immediate: false }
  );

  onUnmounted(() => {
    if (timeoutId) clearTimeout(timeoutId);
    if (typeof stopWatch === 'function') {
      stopWatch();
    }
  });

  return { loading, finish, stop };
}
